import * as React from 'react';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { IDs } from '../../../helpers/IDs';
import parse from 'html-react-parser';
import { filterMethodFulltext } from '../../../core/forms/helpers/filter_method_fulltext';
import DialogWrapper2 from '../../../core/dialog/dialog_wrapper_v2';
import { MailSender } from './MailSender';

interface MailProps extends React.ClassAttributes<any> {
    data: any;
}

interface MailState {
    mailRow: any;
    dataRows: Array<any>;
    refreshCnt: number;
}

export class Mail extends React.Component<MailProps, MailState> {

    constructor(props: any) {
        super(props);
        this.state = {
            mailRow: null,
            dataRows: null,
            refreshCnt: 0
        };
        this.onDataLoaded = this.onDataLoaded.bind(this);
    }

    render(): JSX.Element {
        const { dataRows, refreshCnt } = this.state;

        const customColumns: Array<any> = [
            {
                accessor: 'inhalt_table',
                Header: 'Inhalt',
                id: 'inhalt_table',
                type: 'text',
                filterMethod: (filter: any, row: any) => filterMethodFulltext(filter, row._original, 'inhalt')
            }
        ];

        const customActions = [{
            key: 'MAIL',
            func: ((row: any) => this.setState({ mailRow: row })),
            info: 'E-Mail erstellen'
        }];

        return <div>
            <WFormsTableWrapper
                key={IDs.ENT_MAIL + refreshCnt}
                entity={IDs.ENT_MAIL}
                module={IDs.MOD_ETOOL_ADMIN}
                data={dataRows}
                actions={['add', 'edit', 'delete']}
                customClass={'Custom-ETA'}
                formLayout={'flowV2'}
                formLayout2={'noneAutoSave'}
                hiddenColumns={['inhalt', 'anhang']}
                showColumnsHelp={true}
                columnWidths={[400]}
                customCssStyle={{
                    formDialogWrapper: { width: 800 }
                }}
                customColumns={customColumns}
                hideExport={true}
                customActions={customActions}
                customFormConfig={{
                    anhang: { hidden: true }
                }}
                onDataLoaded={this.onDataLoaded}
                tablePageSize={5}
            />
            {this.renderMailSender()}
        </div>;
    }

    onDataLoaded(dataRows: Array<any>) {
        const { refreshCnt } = this.state;
        if (Array.isArray(dataRows)) {
            this.processMail(dataRows);
            this.setState({ dataRows, refreshCnt: refreshCnt + 1 });
        }
    }

    processMail(mail: Array<any>) {
        mail.forEach((r: any) => {
            r.inhalt = typeof r.inhalt === 'string' ? r.inhalt : '';
            const p = parse(r.inhalt);
            r.inhalt_parse = p;
            r.inhalt_table = <div style={{ padding: '3px' }}>{p}</div>;
        });
    }

    renderMailSender() {
        const { mailRow } = this.state;
        if (mailRow) {
            return <div>
                <DialogWrapper2
                    title={'E-Mail erstellen'}
                    onAfterClose={() => this.setState({ mailRow: null })}
                >
                    <div style={{ width: 800 }}>
                        <MailSender
                            data={this.props.data}
                            mailRow={mailRow}
                        />
                    </div>
                </DialogWrapper2>
            </div>;
        }
    }
}
